'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _getResourceReducer = require('./getResourceReducer');

var _getResourceReducer2 = _interopRequireDefault(_getResourceReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Lib
var initialState = Immutable.Map({});

// Reducers


var defaultPredicateFn = function defaultPredicateFn(resourceType) {
    return function (action) {
        return action.resource === resourceType;
    };
};

exports.default = function (resourceType, customPredicateFn) {
    var predicateFn = customPredicateFn || defaultPredicateFn(resourceType);

    var resourceReducer = (0, _getResourceReducer2.default)(resourceType);

    var delegateToResource = function delegateToResource(state, action) {
        return function (resourceId) {
            return state.update(resourceId, function (resourceState) {
                return resourceReducer(resourceState || undefined, action);
            });
        };
    };

    var delegateToEachResource = function delegateToEachResource(state, action) {
        return state.withMutations(function (mutableState) {
            return action.ids.forEach(delegateToResource(mutableState, action));
        });
    };

    var delegateToAllResources = function delegateToAllResources(state, action) {
        return state.withMutations(function (mutableState) {
            return state.keySeq().forEach(delegateToResource(mutableState, action));
        });
    };

    return function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
        var action = arguments[1];

        if (!predicateFn(action)) return state;

        if (action.ids) return delegateToEachResource(state, action);
        if (action.id) return delegateToResource(state, action)(action.id);

        return delegateToAllResources(state, action);
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/http/resources/reducers/makeResourceTypeReducer.js
// module id = 471
// module chunks = 0